<template>
  <div v-if="!this.user.loading">
    <v-container class="list">
      <v-row no-gutters class="justify-center">
        <div v-for="department in user.lists.departments.output" :key="department.id" class="col-12 col-sm-4 col-md-3">
          <ItemDepartment :key="department.id" :item="department" v-on:childToParent="departmentToggle" />
        </div>
      </v-row>
    </v-container>
  </div>
</template>

<script>
//import settings from "../settings/settings";
import ItemDepartment from './fragments/itemDepartment';
import helpers from '@/settings/helpers';
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('user');

export default Vue.extend({
  name: 'ListDepartments',
  methods: {
    departmentChange(item) {
      const dataLayerData = {
        event: 'easybooking-click',
        eventCategory: 'services',
        eventAction: 'department-selected',
        departmentAddress: item.address,
        departmentZipcode: item.zipcode,
        departmentCity: item.city,
        departmentEmail: item.contactemail
      };
      helpers.sendGTM(dataLayerData, this.user.config.host);
      const data = {
        change: true,
        response: item,
        test: this.user.config.parameters.parameters.test
      };
      this.$store.dispatch('user/initDepartment', data).then(() => {
        this.$store.dispatch('user/initLoading', false);
      });
    },
    departmentToggle(item) {
      this.departmentChange(item);
    },
    departmentSelect() {
      this.departmentChange(this.value);
    }
  },
  components: {
    ItemDepartment
  },
  computed: mapGetters(['user'])
});
</script>

<style scoped lang="scss">
.list {
  &--hidden-mobile {
    display: none;

    @media (min-width: 960px) {
      & {
        display: block;
      }
    }
  }
}
.dropdown {
  @media (min-width: 960px) {
    & {
      display: none;
    }
  }
}
</style>

<i18n src="../localization/texts.json"></i18n>
